import mitt from 'mitt';
import { btnTd } from '@/api/typing';
import defaultSlotList from '@/components/page-model/slotList';
import { message, Modal, notification } from 'ant-design-vue';
import {
  get_s_product,
  create_product_out_record,
  query_product_in_record_list,
  delete_product_out_record,
} from '@/api/mjstock-model';
import { reactive } from 'vue';
import modalBox from '@/components/form-modal/modal-tools';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';

export const event_obj = mitt();
export const btn_list = [
  {
    name: '作废',
    clazz: 'danger',
    is_show: (record: any) => {
      return record.is_active;
    },
    cb: (record: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      Modal.confirm({
        title: '提示',
        content: '是否作废这条记录[' + record.code + ']',
        onOk() {
          delete_product_out_record({
            product_out_record_id: record.id,
            org_id: current_org?.id,
          }).then(function (res) {
            message.success('作废成功');
            Object.assign(record, res);
          });
        },
        onCancel() {},
      });
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

const in_type = 6; // 采购入库
const title = '新建其他出库'; // 采购入库

export const head_btn_list: btnTd[] = [
  {
    name: title,
    clazz: 'primary',
    cb: () => {
      // 模态框，确认按钮点击。
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const editModal = reactive({
        visible: true,
        loading: false,
        title: title,
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [6, 6],
          },
          fields: [
            {
              type: 'remotemodal',
              name: 'product_in_record_id',
              label: '关联入库单据',
              disabled: false,
              placeholder: '请选择关联入库单据',
              datasourceType: 'remote',
              labelKey: 'code',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstock-productinrecord',
            },
            {
              type: 'input',
              name: 's_product__code',
              label: '产品编码',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 's_product__name',
              label: '产品编码',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 's_product__gg',
              label: '产品规格',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 's_product__dw',
              label: '产品单位',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'position',
              label: '产品库位',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'out_num',
              label: '出库数量',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'single_price',
              label: '产品单价',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'price',
              label: '产品金额',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },

            {
              type: 'datepicker',
              name: 'out_datetime',
              label: '出库日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              showTime: true,
              placeholder: '请填写出库日期',
            },

            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '执行门店',
              disabled: false,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '执行人',
              disabled: false,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
          ],
          rules: {
            out_num: [{ required: true, message: '请输入入库产品数量' }],
            product_in_record_id: [{ required: true, message: '请选择产品' }],
            out_datetime: [{ required: true, message: '请选择入库日期' }],
            shop_id: [{ required: true, message: '请选择执行门店' }],
            staff_id: [{ required: true, message: '请选择执行人' }],
          },
          model: reactive({
            org_id: current_org?.id,
            out_type: in_type,
            out_num: 0,
          }),
          watch: {
            out_num: (data: any) => {
              data.price = data.single_price * data.out_num;
            },
            product_in_record_id: (data: any) => {
              if (data.product_in_record_id && data.product_in_record_id > 0) {
                data.s_product__code = '';
                data.s_product__name = '';
                data.s_product__gg = '';
                data.s_product__dw = '';
                data.single_price = 0;
                data.position = '';
                data.price = 0;
                query_product_in_record_list({
                  org_id: current_org?.id,
                  ids: data.product_in_record_id,
                }).then(function (res: any) {
                  if (res.data && res.data.length > 0) {
                    data.position = res.data[0].position;
                    data.single_price = res.data[0].single_price;
                    data.price = res.data[0].single_price * data.out_num;
                    get_s_product({
                      org_id: current_org?.id,
                      s_product_id: res.data[0].s_product_id,
                    }).then(function (res2: any) {
                      data.s_product__code = res2.code;
                      data.s_product__name = res2.name;
                      data.s_product__gg = res2.gg;
                      data.s_product__dw = res2.dw;
                    });
                  } else {
                    message.error('入库记录找不到');
                  }
                });
              }
            },
          },
        },
        options: {},
        ok: (payload: any) => {
          if (Number(payload.out_num) <= 0) {
            notification.error({
              message: '输入数值错误',
              description: '出库数量要大于0',
            });
            return false;
          }
          return new Promise(resolve => {
            editModal.loading = true;
            create_product_out_record(payload)
              .then(() => {
                message.success('出库记录创建成功');
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
];
